import React from 'react'

import Paper from 'app/components/base/Paper'
import SignUpFeature from 'app/features/Auth/SignUpFeature'

import AuthContainer from '~/components/layouts/AuthContainer'

const SignUpView: RFC = () => {
  return (
    <AuthContainer>
      <Paper sx={{ py: { xs: 5, md: 5 }, px: { xs: 7.3, md: 12.5 } }}>
        <SignUpFeature />
      </Paper>
    </AuthContainer>
  )
}

export default SignUpView
